import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { HttpUrlGenerator } from '@ngrx/data';
import { Update } from '@ngrx/entity';
import { NotificationSettingInterface } from '@shared/api';
import { isNumber } from 'lodash-es';
import { map, Observable } from 'rxjs';
import { CustomDefaultDataService } from '../../custom-default-data-service.class';
import { EntityTypeEnum } from '../../entity.interface';

@Injectable({ providedIn: 'root' })
export class NotificationSettingsDataService extends CustomDefaultDataService<NotificationSettingInterface> {
  constructor(http: HttpClient, httpUrlGenerator: HttpUrlGenerator) {
    super(EntityTypeEnum.NotificationSetting, http, httpUrlGenerator);
  }

  override update(
    update: Update<NotificationSettingInterface>,
  ): Observable<NotificationSettingInterface> {
    return this.http
      .patch(this.entitiesUrl, {
        settings: isNumber(update.id)
          ? [{ id: parseInt(update.id.toString()), ...update.changes }]
          : update.id.split(',').length > 0
            ? update.id.split(',').map((id) => ({
                id: parseInt(id.toString()),
                ...update.changes,
              }))
            : [{ id: parseInt(update.id.toString()), ...update.changes }],
      })
      .pipe(
        map(
          () =>
            ({
              id: update.id as string,
              ...update.changes,
            }) as NotificationSettingInterface,
        ),
      );
  }

  override getAll(): Observable<NotificationSettingInterface[]> {
    return this.http
      .get(this.entitiesUrl)
      .pipe(map((response: any) => response['settings']));
  }
}
